"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsGenericViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.OpsGenericViewFields = {
    [ViewFieldKey_1.default.OPS_TYPE]: {
        key: ViewFieldKey_1.default.OPS_TYPE,
        label: () => lib_i18n_1.default.t('op-type'),
        description: () => lib_i18n_1.default.t('op-type-description'),
        sortable: false,
        fieldType: StaticFieldType_1.default.OP_TYPE,
        propertyName: 'type',
        width: 150,
        gqlFields: 'type',
    },
    [ViewFieldKey_1.default.OPS_ASSIGNEE]: {
        key: ViewFieldKey_1.default.OPS_ASSIGNEE,
        label: () => lib_i18n_1.default.t('assignee'),
        description: () => lib_i18n_1.default.t('assignee-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.OP_ASSIGNEE,
        width: 150,
        gqlFields: 'allPTsPermitted, staff { id, title }, positions { id, title }, teams { id, title }',
    },
    [ViewFieldKey_1.default.OPS_ASSOCIATED_STAFF]: {
        key: ViewFieldKey_1.default.OPS_ASSOCIATED_STAFF,
        label: () => lib_i18n_1.default.t('associated-staff'),
        description: () => lib_i18n_1.default.t('associated-staff-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.RELATED_USER,
        propertyName: 'associatedStaff',
        width: 150,
        gqlFields: 'associatedStaff {  id, title, profileImageUrl }',
    },
};
exports.default = exports.OpsGenericViewFields;
